import React, { useState, useContext, useEffect } from 'react';
import styled from '../../../libs/styled.es.js';
import { DropdownContext } from './DropdownContext.es.js';

const StyledDiv = styled.div`
  width: 100%;
  &:focus {
    outline: none;
  }
`;
const DropdownToggle = ({
  children,
  className
}) => {
  const [anchor, setAnchor] = useState(null);
  const {
    state: { toggle, toggleType },
    dispatch
  } = useContext(DropdownContext);
  useEffect(() => {
    dispatch({ type: "SET_REFERENCE", payload: anchor });
  }, [anchor]);
  return /* @__PURE__ */ React.createElement(StyledDiv, {
    className,
    ref: setAnchor,
    onClick: toggleType === "click" ? toggle : null,
    onKeyUp: toggleType === "click" ? toggle : null,
    tabIndex: 0
  }, children);
};

export { DropdownToggle };
